import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import { profilePromotionColumns } from "../../tables/profilePromotionColumns";
import { can } from "../../utils/can";
import ProfilePromotionalHistory from "./ProfilePromotionalHistory";

export default function ProfilePromotion() {

  const PAGE_SIZE = 10;

  // ================= STATES =================
  const [formData, setFormData] = useState({
    profileID: "",
    listing: "",
    fromDate: "",
    toDate: "",
    position: "",
  });

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [errrMessage, setErrrMessage] = useState("");

  const [member, setMember] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);

  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  // history modal state
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyProfileID, setHistoryProfileID] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  // ================= VALIDATION =================
  const validate = () => {
    let temp = {};

    if (!formData.profileID) temp.profileID = "Profile ID is required";
    if (!formData.listing) temp.listing = "Listing is required";
    if (!formData.fromDate) temp.fromDate = "From date is required";
    if (!formData.toDate) temp.toDate = "To date is required";
    if (!formData.position) temp.position = "Position is required";

    if (
      formData.fromDate &&
      formData.toDate &&
      new Date(formData.fromDate) > new Date(formData.toDate)
    ) {
      temp.toDate = "To date must be greater than From date";
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  // ================= INPUT HANDLER =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ================= LIST API =================
  const fetchList = async () => {
    setListLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/profile-promotion/promotion-list?page=${page}&limit=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      setMember(data.data || []);
      setTotalPages(data.totalPages || 1);
    } catch (err) {
      console.error(err);
    }
    setListLoading(false);
  };

  useEffect(() => {
    
    fetchList();
  }, [page, pageSize, sortBy, sortOrder]);

  // ================= INSERT / UPDATE =================
  const handleSubmit = async (e) => {
    if(can("profile_promotion", "create") === false){
      alert("You don't have permission to edit renew members.");
      return;
    }

    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await fetch(
        editId
          ? `${API_URL}/api/admin/profile-promotion/promotion-list/update/${editId}`
          : `${API_URL}/api/admin/profile-promotion/promotion-create`,
        {
          method:  "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if(data.success){
        setSuccess(editId ? "Updated successfully" : "Added successfully");
        resetForm();
        fetchList();
        setErrrMessage("");
      }else{
        setErrrMessage(data.message);
      }
   

    } catch (err) {
      console.error(err);
    }
  };

  // ================= EDIT =================
  const handleEdit = (row) => {
    if(can("profile_promotion", "edit") === false){
      alert("You don't have permission to edit renew members.");
      return;
    }

    setEditId(row._id);
    setFormData({
      profileID: row.member_id?.profile_id || "",
      listing: row.listing || "",
      fromDate: row.fromDate?.slice(0, 10) || "",
      toDate: row.toDate?.slice(0, 10) || "",
      position: row.position || "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if(can("profile_promotion", "delete") === false){
      alert("You don't have permission to edit renew members.");
      return;
    }

    if (!window.confirm("Are you sure?")) return;

    try {
      await fetch(`${API_URL}/api/admin/profile-promotion/promotion-list/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchList();
    } catch (err) {
      console.error(err);
    }
  };

  // ================= RESET =================
  const resetForm = () => {
    setFormData({
      profileID: "",
      listing: "",
      fromDate: "",
      toDate: "",
      position: "",
    });
    setEditId(null);
    setErrors({});
  };

  const fetchHistory = async (profileID) => {
    setHistoryLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/profile-promotion/history/${profileID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      if (data.success) {
        setHistoryData(data.data || []);
      } else {
        setHistoryData([]);
      }
    } catch (err) {
      console.error(err);
      setHistoryData([]);
    }
    setHistoryLoading(false);
  };

  const isOpen = (profileID) => {
    if (!profileID) return;
    setHistoryProfileID(profileID);
    setHistoryOpen(true);
    fetchHistory(profileID);
  };
  // ================= COLUMNS =================
  const columns = profilePromotionColumns({
    handleEdit,
    handleDelete,
    PAGE_SIZE: pageSize,
    isOpen
  });

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Profile Promotion" />

        <div className="right_col" role="main">
         

          <div className="x_panel">
            <div className="x_title">
              <h2>{editId ? "Edit" : "Add"} Promotion</h2>
             
              <div className="clearfix" />
              {errrMessage ? <div className="alert alert-danger">{errrMessage}</div> : null}
            </div>

            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="filtercont">
                  <div className="row">

                    <div className="col-sm-2">
                      <label>Profile ID</label>
                      <input
                        type="text"
                        name="profileID"
                        className="form-control"
                        value={formData.profileID}
                        onChange={handleChange}
                      />
                      <p className="text-danger">{errors.profileID}</p>
                    </div>

                    <div className="col-sm-2">
                      <label>Listing</label>
                      <select
                        name="listing"
                        className="form-control"
                        value={formData.listing}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Home Page">Home Page</option>
                        <option value="Search And Match">Search And Match</option>
                      </select>
                      <p className="text-danger">{errors.listing}</p>
                    </div>

                    <div className="col-sm-2">
                      <label>From Date</label>
                      <input
                        type="date"
                        name="fromDate"
                        className="form-control"
                        value={formData.fromDate}
                        onChange={handleChange}
                      />
                      <p className="text-danger">{errors.fromDate}</p>
                    </div>

                    <div className="col-sm-2">
                      <label>To Date</label>
                      <input
                        type="date"
                        name="toDate"
                        className="form-control"
                        value={formData.toDate}
                        onChange={handleChange}
                      />
                      <p className="text-danger">{errors.toDate}</p>
                    </div>

                    <div className="col-sm-2">
                      <label>Position</label>
                      <select
                        name="position"
                        className="form-control"
                        value={formData.position}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {[...Array(50)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                      <p className="text-danger">{errors.position}</p>
                    </div>

                    <div className="col-sm-2">
                      <label>&nbsp;</label>
                      <button type="submit" className="btn sitebtn w-100">
                        {editId ? "Update" : "Submit"}
                      </button>
                      <p className="text-success">{success}</p>
                    </div>

                  </div>
                </div>

              </form>
            </div>

            <AdminDataTable
              columns={columns}
              data={member}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              loading={listLoading}
              onPageChange={setPage}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
              sortBy={sortBy}
              sortOrder={sortOrder}
            />
          </div>
        </div>
        
        <ProfilePromotionalHistory
          show={historyOpen}
          onClose={() => {
            setHistoryOpen(false);
            setHistoryData([]);
          }}
          profileID={historyProfileID}
          history={historyData}
          loading={historyLoading}
        />

        <Footer />
      </div>
    </div>
  );
}
